<template>
  <div>
    <a-card :loading="loading">
      <div slot="title" class="title-bar">
        <div class="title-name">我的标记集</div>
        <a-button class="btn-add" shape="circle" @click="handleClickAddSet">
          <i class="iconfont icon-icon-test"></i>
        </a-button>
      </div>
      <a-list
        itemLayout="horizontal"
        :dataSource="markerSetList">
        <a-list-item slot="renderItem" slot-scope="item" @click="handleClickMarkerSet(item)">
           <a-list-item-meta
            :description="item.createdAt | formatDate">
            <div slot="title">
              <a-tag v-if="item.pinned" color="blue" class="pin-badge">置顶</a-tag>
              {{item.name}}
            </div>
          </a-list-item-meta>
          <a slot="actions" @click.stop="handleClickEdit(item)">编辑</a>
          <a slot="actions" @click.stop="handleClickDelete(item)">删除</a>
        </a-list-item>
      </a-list>
    </a-card>
    <marker-set-modal
      :visible.sync="markerSetModealVisible"
      :markerSet="currentMarkerSet"
      @update="initData">
    </marker-set-modal>
  </div>
</template>

<script>
import MarkerSetModal from '@/components/marker-set-modal/index.vue';

export default {
  components: {
    MarkerSetModal,
  },
  data() {
    return {
      markerSetList: [],
      markerSetModealVisible: false,
      currentMarkerSet: null,
      loading: false,
    };
  },
  methods: {
    async initData() {
      let res;
      try {
        this.loading = true;
        res = await this.$api.proxy.markerSetListByCurrentUser();
        this.loading = false;
      } catch (error) {
        this.loading = false;
        return;
      }
      const resultData = JSON.parse(res.data.data.resp_data).data;
      this.markerSetList = resultData;
    },
    handleClickMarkerSet(markerSet) {
      console.log('点击了', markerSet);
      this.$router.push(`/main/marker-set/${markerSet._id}`);
    },
    handleClickEdit(markerSet) {
      this.markerSetModealVisible = true;
      this.currentMarkerSet = markerSet;
    },
    handleClickDelete(markerSet) {
      this.$confirm({
        title: '提示',
        content: `确定删除标记集 ${markerSet.name} 吗？`,
        onOk: async () => {
          await this.$api.proxy.markerSetDelete({
            id: markerSet._id,
          });
          this.$message.success('删除成功');
          this.initData();
        },
        onCancel() {},
      });
    },
    handleClickAddSet() {
      this.markerSetModealVisible = true;
      this.currentMarkerSet = null;
    },
  },
  filters: {
    formatDate(dateString) {
      function paddingNumber(num) {
        return num.toString().length === 2 ? num : `0${num}`;
      }
      const date = new Date(dateString); // 返回当前时间对象
      const year = date.getFullYear();
      const month = paddingNumber(date.getMonth() + 1);
      const day = paddingNumber(date.getDate());
      const hours = paddingNumber(date.getHours());
      const minutes = paddingNumber(date.getMinutes());

      const isEqYear = new Date().getFullYear() === year;
      const dateArray = isEqYear ? [month, day] : [year, month, day];

      return `${dateArray.join('/')} ${hours}:${minutes}`;
    },
  },
  created() {
    this.initData();
  },
};
</script>

<style scoped>
.title-bar {
  display: flex;
}
.title-name {
  flex: 1;
  text-align: center;
  line-height: 32px;
}

.btn-add {
  float: right;
}

* /deep/ .ant-list-item:hover {
  cursor: pointer;
  /* background-color: #e6f7ff; */
}

.pin-badge {
  margin-right: 4px;
  padding: 0 4px;
  font-size: 10px;
  line-height: 16px;
  vertical-align: middle;
}

.ant-card {
  display: flex;
  height: 100vh;
  flex-direction: column;
}

* /deep/ .ant-card-body {
  flex: 1;
  overflow-y: auto;
}
</style>
